<template>

    <v-card>
        <v-card-title>{{ `${newView ? 'New' : ''} ${viewTypeText} View` }}</v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form ref="viewForm" @submit.prevent v-model="viewFormValid" :lazy-validation="true">
                <v-row>
                    <template v-if="newView">
                        <v-col cols="12">
                            <v-text-field label="New View Name" color="#c42111" v-model="viewName" :rules="[validation.required(viewName, 'View Name'), validation.unique(viewName, $props.views, $store.state.user.user_id)]" />
                        </v-col>
                        <v-col cols="6">
                            <v-switch label="Make view public" color="#c42111" v-model="viewPublic" />
                        </v-col>
                        <v-col cols="6" v-if="showDefaultControl">
                            <v-switch label="Set as default view" color="#c42111" v-model="viewDefault" />
                        </v-col>
                    </template>

                    <template v-if="!newView">
                        <div class="view-action-container">
                            <v-btn class="mr-9" color="#c42111" height="50" @click="createNewClick"><v-icon class="mr-1">mdi-card-plus</v-icon> Create New</v-btn>
                            <v-btn class="ml-9" color="#c42111" height="50" @click="overwriteClick"><v-icon class="mr-1">mdi-refresh</v-icon> Overwrite</v-btn>
                        </div>
                    </template>
                </v-row>
            </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
            <v-btn text @click="saveClick" v-if="newView">Save</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script>
export default {
    name: 'ViewsFavsDetails',
    props: ['viewType', 'selectedView', 'views'],
    data: () => ({
        viewFormValid: true,
        newView: false,
        viewName: '',
        viewPublic: false,
        viewDefault: false,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            unique: (value, views, userId) => (!value || !views.some(v => {return (v.user_id == userId && v.view_name == value.trim())})) || 'This View Name is already is use for this user. '
        }
    }),

    computed: {
        viewTypeText: function() {
            if(this.$props.viewType == 'alarm') {
                return 'Alarm';
            }
            else if(this.$props.viewType == 'issue') {
                return 'Issue';
            }
            else if(this.$props.viewType.startsWith('report')) {
                return 'Report';
            }
            else if(this.$props.viewType == 'geomap') {
                return 'Geo Map';
            }
            else if(this.$props.viewType == 'alarm_email') {
                return 'Alarm Email Template';
            }
            else {
                return '';
            }
        },

        showDefaultControl() {
            if(this.$props.viewType == 'alarm_email') {
                return false;
            }
            return true;
        }
    },

    methods: {
        saveClick: function() {
            if(this.$refs.viewForm.validate()) {
                if(this.newView) {
                    this.$emit('new', {viewName: this.viewName.trim(), viewPublic: this.viewPublic, viewDefault: this.viewDefault});
                }
            }
        },

        createNewClick: function() {
            console.log('createNewClick');
            if(this.$props.viewType == 'alarm_email') {
                // for email template views that have their own viewName control we want to set the initial state of the name.
                this.viewName = this.$props.selectedView.view_name;
            }
            this.newView = true;
        },

        overwriteClick: function() {
            this.$emit('overwrite');
        }

    },

    created() {
        console.log('selectedView: ', this.$props.selectedView);

        if(!this.$props.selectedView || this.$props.selectedView.user_id != this.$store.state.user.user_id) { // This is a new view
            this.newView = true;
            // if(this.$props.viewType == 'alarm_email') {
            //     // for email template views that have their own viewName control we want to set the initial state of the name.
            //     this.viewName = this.$props.selectedView.view_name;
            // }
        }
        else {
            this.viewName = this.$props.selectedView.name;
        }

    },

    mounted() {
    },

};
</script>

<style scoped>

    .view-action-container {
        width: 100%;
        text-align: center;
        margin-top: 2em;
        margin-bottom: 1em;
    }
    
</style>

